import * as XLSX from 'xlsx';

// Color mapping function
const getRowColor = (type) => {
    if (type === 'mediaExpense') return '#FFAEAE';
    if (type === 'additionalExpense') return '#FFCCB0';
    if (type === 'ClosingAmount') return '#C0FFCD';
    if (type === 'budget') return '#B0E0E6';
    return ''; // Default color if no condition matches
};

const genrateExcel = async (data, defaultName) => {
    const fileName = prompt('Enter the name for your sheet:', defaultName);
    if (!fileName) return; // If no name is entered, exit the function
    
    // Ensure the data is not empty
    if (!data || data.length === 0) {
        alert('No data to export');
        return;
    }

    try {
        // Prepare data for Excel
        const preparedData = data?.map((item) => {
            if (item?.type === "budget") {
                return {
                    Date: item.date,
                    User: item.user,
                    'User Email': item.userEmail,
                    Description: item.description,
                    Amount: item.amount,
                    Type: item.type,
                    Balance: item.balance,
                }
            } else {
                return {
                    Date: item.date,
                    User: item.user,
                    'User Email': item.userEmail,
                    Description: item.description,
                    Amount: item.amount,
                    Type: item.type,
                    // Balance: item.balance,
                }
            }
        });

        // Create worksheet
        const worksheet = XLSX.utils.json_to_sheet(preparedData);

        // Style the headers
        const headerRange = XLSX.utils.decode_range(worksheet['!ref'] || 'A1');
        for (let col = headerRange.s.c; col <= headerRange.e.c; col++) {
            const headerCell = XLSX.utils.encode_cell({ r: 0, c: col });
            if (!worksheet[headerCell]) continue;
            
            worksheet[headerCell].s = {
                font: { 
                    bold: true, 
                    color: { rgb: "000000" } 
                },
                fill: { 
                    fgColor: { rgb: "E0E0E0" } 
                }
            };
        }

        // Add cell coloring based on type
        preparedData.forEach((item, index) => {
            const rowColor = getRowColor(item.Type);
            if (rowColor) {
                for (let col = 0; col < Object.keys(item).length; col++) {
                    const cellAddress = XLSX.utils.encode_cell({ r: index + 1, c: col });
                    if (!worksheet[cellAddress]) continue;
                    
                    worksheet[cellAddress].s = {
                        ...(worksheet[cellAddress].s || {}),
                        fill: { 
                            fgColor: { rgb: rowColor.replace('#', '') } 
                        }
                    };
                }
            }
        });

        // Create workbook and add worksheet
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Transactions');

        // Generate Excel file
        XLSX.writeFile(workbook, `${fileName}_${new Date().toISOString().split('T')[0]}.xlsx`);

    } catch (error) {
        console.error('Error downloading Excel file:', error);
        alert('Failed to download Excel file');
    }
};

export default genrateExcel;